import Download from '@/apps/index/mixins/download'
import ScrollToTop from '@/apps/index/mixins/scrollToTop'
import { getInitInfo, getRegions, paperDoc, paperList } from '@/apps/index/models/api'
import { NoResult, PaperItem } from '@/components'
import SingleRowSelect from '@/components/common/singleRowSelect/SingleRowSelect.vue'
import SmallBtnSkeleton from '@/components/common/small-btn-skeleton'
import LessInfo from '@/components/LessInfo'
import MainTemplate from '@/components/MainTemplate.vue'
import { Component, Mixins, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import PaperPending from '../components/paper-pending'
import TpAppNameMixins from '@/components/common/mixins/tp-appname'
import Cookies from 'js-cookie'

const POSITION = '试卷列表页'
// 直辖市
const DIRECT_CITIES = [110000, 120000, 500000, 310000]
const TERM_CHOICE = [
  [0, '全部'],
  [1, '上学期'],
  [2, '下学期']
]
const TP_APP_NAME = Cookies.get('TP_AppName')
@Component({
  components: {
    MainTemplate,
    SingleRowSelect,
    NoResult,
    PaperItem,
    LessInfo,
    PaperPending,
    SmallBtnSkeleton
  }
})
export default class PaperList extends Mixins(Download, ScrollToTop, TpAppNameMixins) {
  public provinceChoice: any[] = []
  public gradeChoice = []
  public yearChoice = []
  public termChoice: any[] = []
  public papertypeChoice: any[] = []
  public cityChoice: any[] = []
  public sectionChoice: any[] = []
  public flag = true
  public keyword = ''
  // 试卷信息
  public contentData = []
  public page = 1
  public perPage = 10
  public total = 0
  public loading = true // 初始化loading为true，默认应该为pending状态
  public loadingModal = false
  // 筛选条件
  public sortType = 1 // 1 综合排序  2 时间排序 默认1
  public typed = false // 是否为精排卷，默认 否 后端对应参数 1为 精
  public famousPaper = false // 是否为名校试卷
  public pageTotal = 0 //
  // 获取省市区
  public province = (this.regions && this.regions.length > 0 && this.regions[0]) || { code: 0, name: '全部' }
  public grade = [0, '全部']
  public city = this.defaultCity
  public section = this.defaultSection
  public year = [0, '全部']
  public paperType = [0, '全部']
  public term = [0, '全部']
  public checkUserOk = false
  // 筛选条件状态，默认为 true
  public optionsLoading = true
  // 获取学科
  private get subject() {
    return this.$store.state.subject
  }
  // 用户地区
  private get regions() {
    const user = this.$store.state.user_info
    const regions = user && user.regions
    if (this.$route.query && this.$route.query.paper_type) {
      return { code: 0, name: '全部' }
    }
    return regions
  }
  private get moduleName() {
    return this.$route.meta.label
  }
  // 展示状态
  public get switchTemplate() {
    if (this.loading) {
      return 'pending'
    } else {
      if (this.contentData.length > 0) {
        return 1
      } else {
        return 2
      }
    }
  }
  // 用户信息
  public get userName() {
    return this.$store.state.user_info && this.$store.state.user_info.nickname
  }
  // 市、区显示控制
  public get showName() {
    if (!(this.province && this.province.name)) return
    return DIRECT_CITIES.indexOf(this.province.code) > -1 ? '区：' : '市：'
  }
  // 默认市
  public get defaultCity() {
    if (TP_APP_NAME) {
      if (this.regions && this.regions.length > 0) {
        if (DIRECT_CITIES.indexOf(this.regions[0].code) > -1) {
          return this.regions[2]
        } else {
          return this.regions[1]
        }
      } else {
        return { code: 0, name: '全部' }
      }
    } else {
      return { code: 0, name: '全部' }
    }
  }

  // 默认区
  public get defaultSection() {
    if (TP_APP_NAME) {
      if (this.regions && this.regions.length > 0) {
        if (DIRECT_CITIES.indexOf(this.regions[0].code) > -1) {
          return { code: 0, name: '全部' }
        } else {
          return this.regions[2]
        }
      } else {
        return { code: 0, name: '全部' }
      }
    } else {
      return { code: 0, name: '全部' }
    }
  }

  // 获取默认市列表
  @Watch('regions', { deep: true })
  public onRegionsChange(val) {
    if (val && val.length > 0) {
      this.province = val[0]
      if (this.tpAppName) {
        if (DIRECT_CITIES.indexOf(val[0].code) > -1) {
          this.city = val[2]
        } else {
          this.city = val[1]
          this.section = val[2]
        }
      } else {
        this.city = { code: 0, name: '全部' }
        this.section = { code: 0, name: '全部' }
      }
      this.getRegions(val[0].code, 'city')
    }
  }
  // 学科切换
  @Watch('subject', { immediate: true })
  public onSubjectChange(val, old) {
    let query: any = this.$route.query
    if (query && query.paper_type) {
      this.paperType = JSON.parse(query.paper_type)
    }
    if (val && val.value) {
      if (old && val.value !== old.value) {
        this.reset()
      }
      this.getInitInfo()
      this.getList(1)
    }
  }
  // 获取条件信息
  public async getInitInfo() {
    try {
      this.optionsLoading = true
      const data: any = await getInitInfo({ subject_id: this.subject && this.subject.value })
      if (data.success) {
        this.provinceChoice = [{ code: 0, name: '全部' }, ...data.data.region_choices]
        this.gradeChoice = data.data.grade_choices
        this.yearChoice = data.data.year_choices
        this.termChoice = TERM_CHOICE
        this.papertypeChoice = [[0, '全部'], ...data.data.paper_type_choices]
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.optionsLoading = false
    }
  }
  // 点击展开/收起
  public switchIt(val: boolean) {
    this.flag = !this.flag
  }
  // 地区（省）
  public clickRegion(item) {
    this.province = item
    // 市、区重置
    this.city = { code: 0, name: '全部' }
    this.section = { code: 0, name: '全部' }
    if (item && item.name === '全部') {
      this.cityChoice = []
      this.sectionChoice = []
    }
    this.getRegions(item.code, 'city')
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '地区',
      value: item.name,
      paper_type: ''
    })
  }
  // 市
  public clickCity(item) {
    this.city = item
    // 区重置
    this.section = { code: 0, name: '全部' }
    if (item && item.name === '全部') {
      this.sectionChoice = []
    }
    this.getRegions(item.code, 'district')
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '市',
      value: item.name,
      paper_type: ''
    })
  }
  // 区
  public clickSection(item) {
    this.section = item
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '区',
      value: item.name,
      paper_type: ''
    })
  }
  // 选择年级
  public clickGrade(item) {
    this.grade = item
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '年级',
      value: item[1],
      paper_type: ''
    })
  }
  // 试卷类型
  public clickPaperType(item) {
    this.paperType = item
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '类型',
      value: item[1],
      paper_type: ''
    })
  }
  // 年份
  public clickYear(item) {
    this.year = item
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '年份',
      value: item[1],
      paper_type: ''
    })
  }
  // 选择学期
  public clickTerm(item) {
    this.term = item
    this.getList(1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '学期',
      value: item[1],
      paper_type: ''
    })
  }
  // 精排卷筛选
  public onVersionChange(e) {
    this.typed = e.target.checked
    // 筛选
    this.getList(1)
    if (this.typed) {
      window['sensors'].track('TIKU_afterFilter_clk', {
        moduleName: this.moduleName,
        filter: '精排卷'
      })
    }
  }
  // 名校试卷筛选
  public onFamousChange(e) {
    this.famousPaper = e.target.checked
    // 筛选
    this.getList(1)
    if (this.famousPaper) {
      window['sensors'].track('TIKU_afterFilter_clk', {
        moduleName: this.moduleName,
        filter: '名校试卷'
      })
    }
  }
  // 切换分页
  public onPageChange(val) {
    this.getList(val)
    this.scrollTo(0) // 滚动到顶
  }
  // 搜索
  public onSearch() {
    this.getList(1)

    window['sensors'].track('TIKU_search', {
      keyword: this.keyword || '',
      moduleName: this.moduleName
    })
  }
  // 清空搜索内容
  public onKeywordchange() {
    const txt = String(this.keyword).trim()
    if (txt === '') {
      this.getList(1)
    }
  }
  // 点击排序
  public onClickRanger(val) {
    this.sortType = val
    this.getList(1)

    window['sensors'].track('TIKU_afterFilter_clk', {
      moduleName: this.moduleName,
      filter: this.sortType === 1 ? '综合排序' : '时间排序'
    })
  }
  // 重置
  public reset() {
    this.keyword = ''
    this.contentData = []
    this.page = 1
    this.typed = false
    this.famousPaper = false
    this.sortType = 1
  }
  // 下载
  public clickDownload(val: any) {
    if (!this.userName) {
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }

    let param = val
    window['sensors'].track('TIKU_Download', {
      proSource: this.moduleName,
      content: '试卷',
      paper_subject: this.subject.label,
      is_not: val.is_excellent ? '是' : '否'
    })

    this.getPaperDoc(val.paper_id, param)
  }
  // 获取地区信息
  public async getRegions(val, type) {
    if (val !== 0) {
      let obj = {
        pcode: val
      }
      try {
        const { data } = await getRegions(obj)
        if (type === 'city') {
          this.cityChoice = [{ code: 0, name: '全部' }, ...data]
        } else {
          if (data && data.length) {
            this.sectionChoice = [{ code: 0, name: '全部' }, ...data]
          } else {
            this.sectionChoice = []
          }
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
  // 下载
  public async getPaperDoc(val, obj?: any) {
    let count = 0
    let req: any = {
      subject_id: this.subject.value,
      paper_id: val
    }
    if (obj) {
      req = { ...req, ...obj }
    }
    this.loadingModal = true
    try {
      const data: any = await paperDoc(req)
      if (data.error && data.error == '请登录') {
        this.$store.commit('SET_LOGINMODAL', true)
      }
      if (data.success) {
        this.getSource(data.data.task_id, count, req.subject_id, val, '')
      }
    } catch (e) {
      this.loadingModal = false
    }
  }
  // 试卷列表
  // tslint:disable-next-line:cyclomatic-complexity
  public async getList(page: number) {
    let regionCode = this.province && this.province.code
    if (!~~this.subject.value) {
      return
    }
    if (this.section && this.section.code) {
      regionCode = this.section.code
    } else if (this.city && this.city.code) {
      regionCode = this.city.code
    }
    this.page = Number(page)
    let obj: any = {
      subject_id: ~~this.subject.value,
      region_code: regionCode,
      city: this.city && this.city.code,
      district: this.section && this.section.code,
      year: this.year[0],
      grade: this.grade && this.grade[0],
      keyword: this.keyword || '',
      page: this.page,
      per_page: this.perPage,
      is_excellent: Boolean(this.typed),
      is_famous_school: this.famousPaper,
      sort_type: this.sortType,
      paper_type: this.paperType && this.paperType[0],
      term: this.term[0]
    }
    if (!this.loading) {
      this.loading = true
    }
    try {
      const { data, total }: any = await paperList(obj)
      if (this.loading) {
        this.loading = false
      }
      if (data && data.length > 0) {
        this.contentData = data
        this.total = total
        if (this.total >= 100 * this.perPage) {
          this.pageTotal = 100 * this.perPage
        } else {
          this.pageTotal = this.total
        }
      } else {
        this.contentData = []
        this.total = 0
      }
    } catch (e) {
      if (this.loading) {
        this.loading = false
      }
      this.contentData = []
      this.total = 0
    } finally {
      this.loading = false
    }
  }
}
